module.exports = __webpack_public_path__ + "img/logo-isotype.b91c631.png";